/* tslint:disable */
import colors from "./colors";

const theme = {
  spacing: {
    small: 8,
    standard: 24,
  },

  /* Get the color palette from colors.js */
  colors,

  /* General theme settings */
  backgroundColor: colors.OffWhite,
  backgroundDarkColor: colors.Clay100,
  borderRadius: "4",
  transition: "300ms ease-out",

  breakpoints: {
    smallTabletUp: "@media (min-width: 601px)",
    tabletUp: "@media (min-width: 769px)",
    tabletLandscapeUp: "@media (min-width: 881px)",
    desktopUp: "@media (min-width: 1200px)",
    desktopDown: "@media (max-width: 1200px)",
    largeDesktopUp: "@media (min-width: 1440px)",
    smallTabletDown: "@media (max-width: 600px)",
    tabletDown: "@media (max-width: 768px)",
    tabletLandscapeDown: "@media (max-width: 880px)",
  },

  /* App header bar */
  headerHeight: "56",
  headerBackgroundColor: colors.OffWhite,

  /* Sidebar */
  sideBarWidth: "256",
  sideBarBackgroundColor: colors.Teal100,

  /* Typography */
  primaryFont: "Apercu Pro Regular",
  baseFontSize: "16px",
  fontSizes: {
    xsmall: "0.8em",
    small: "1.0em",
    medium: "1.25em",
    large: "1.563em",
    xlarge: "1.953125em",
    x2large: "2.441em",
    x3large: "3.051875em",
    x4large: "3.815em",
    x5large: "4.768em",
  },

  /* Text colors */
  primaryColor: colors.Transparent.Black80,
  primaryDarkColor: colors.Transparent.White98,
  secondaryColor: colors.Transparent.Black58,
  secondaryDarkColor: colors.Transparent.White80,

  /* Links */
  lightLinkColor: colors.Teal80,
  darkLinkColor: colors.Red100,
  lightLinkHoverColor: colors.Teal69,
  darkLinkHoverColor: colors.Red80,

  /* Buttons */
  primaryButton: {
    buttonColor: colors.Red80,
    borderColor: colors.Red100,
    textColor: colors.Transparent.White98,
    buttonHoverColor: colors.Red100,
    borderHoverColor: colors.Red100,
    textHoverColor: colors.White,
    buttonActiveColor: colors.Red80,
    borderActiveColor: colors.Red100,
    textActiveColor: colors.Transparent.White86,
  },

  secondaryButton: {
    buttonColor: colors.Teal12,
    borderColor: colors.Teal100,
    textColor: colors.Teal100,
    buttonHoverColor: colors.Teal100,
    borderHoverColor: colors.Teal100,
    textHoverColor: colors.OffWhite,
    buttonActiveColor: colors.Teal60,
    borderActiveColor: colors.Teal100,
    textActiveColor: colors.OffWhite,
  },

  flatLightButton: {
    textColor: colors.Red100,
    textHoverColor: colors.Red80,
    textActiveColor: colors.Red100,
  },

  flatDarkButton: {
    textColor: colors.Turquoise100,
    textHoverColor: colors.Turquoise60,
    textActiveColor: colors.Turquoise100,
  },

  /* Horizontal rules */
  lightHRColor: colors.Transparent.Black20,

  /* Input Labels */
  labelColor: colors.Transparent.Black80,
  labelColorHover: colors.Black,

  /* Inputs */
  inputBackgroundColor: colors.Transparent.White80,
  inputBorderColor: colors.Transparent.Black14,
  inputBorderColorHover: colors.Transparent.Black33,
  inputBorderColorFocus: colors.Teal80,
  inputColor: colors.Transparent.Black80,
  inputColorFocus: colors.Black,
  inputHelperTextColor: colors.Transparent.Black58,
  inputErrorColor: colors.Red100,

  inputSizes: {
    xsmall: 3,
    small: 6,
    medium: 8,
    large: 15,
  },

  /* Paper */
  paperColor: colors.White,
  paperShadowColor: colors.Transparent.Black14,

};

export default theme;
/* tslint:enable */
